import { Controller } from "@hotwired/stimulus";

// Disables associated submit button(s) until at least one checkbox is checked.
// Place on a group of checkboxes - shared/_checkbox_collection does it for you,
// given `required` - or on a <form> to treat all of its checkboxes as one group.
export default class extends Controller {
  connect() {
    this.#sync();
  }

  sync() {
    this.#sync();
  }

  #sync() {
    const satisfied = this.#groups.every(
      (group) => group.querySelector("input[type='checkbox']:checked") !== null
    );

    this.#submits.forEach((btn) => (btn.disabled = !satisfied));
  }

  // A form can hold several groups, and they share its submit buttons, so every
  // group has to be satisfied - not just the one that changed.
  get #groups() {
    const groups = [...this.#form.querySelectorAll(`[data-controller~="${this.identifier}"]`)];

    return groups.length ? groups : [this.#form];
  }

  // `closest` counts the element itself, so this is the form either way.
  get #form() {
    return this.element.closest("form") ?? this.element;
  }

  get #submits() {
    return [
      ...this.#form.querySelectorAll("[type='submit']"),
      ...document.querySelectorAll(`[form="${this.#form.id}"][type='submit']`),
    ];
  }
}
